export const isBlobPreviewUrl = (url) => typeof url === 'string' && url.startsWith('blob:');

export const revokeBlobPreviewUrl = (url) => {
  if (isBlobPreviewUrl(url)) {
    URL.revokeObjectURL(url);
  }
};

export const createBlobPreviewUrl = (file) => URL.createObjectURL(file);

export const blobToCoverImageFile = (blob, fileName = 'cover-image.png') =>
  new File([blob], fileName, { type: blob.type || 'image/png' });
